// import React, { useState } from "react";
// import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
// import MarkerClusterGroup from "react-leaflet-cluster";
// import L from "leaflet";
// import { Table,Button } from "reactstrap";

// import "leaflet/dist/leaflet.css";
// import {Modal} from "react-bootstrap"
// import { useGetCrmBankingDocumentsByIdQuery } from "features/onboarding/users/farmer/farmerApiSlice";
// const markerIcon = new L.Icon({
//   iconUrl: "https://cdn-icons-png.flaticon.com/512/9410/9410621.png",
//   iconSize: [40, 40],
//   iconAnchor: [17, 46],
//   popupAnchor: [0, -46],
// });

// const CattleInsurance = ({ cattleDetails }) => {
//   const[id,setId]=useState("")
//   const { data: data } = useGetCrmBankingDocumentsByIdQuery(id);

//   const [center] = useState([28.576592977786234, 77.31433377113422]);
//   const [modalData, setModalData] = useState([]);
//   const [isModalOpen, setModalOpen] = useState(false)

//   const validLocations = cattleDetails
//     ?.flatMap((detail) =>
//       detail?.lead_details?.map((lead) => {
//         const serviceDetails = lead?.service_details || {};
//         return {
//           id: detail.id,
//           fullName: detail.full_name || "N/A",
//           cattleAge: serviceDetails.cattle_age || "N/A",
//           cattleSpecies: serviceDetails.cattle_species || "N/A",
//           address: serviceDetails.address || "N/A",
//           cattleBreed: serviceDetails.cattle_breed || "N/A",
//           cattleColor: serviceDetails.cattle_color || "N/A",
//           cattleSumInsured: serviceDetails.cattle_sum_insured || "N/A",
//           latitude: serviceDetails.latitude,
//           longitude: serviceDetails.longitude,
//         };
//       })
//     )
//     .filter(
//       (item) =>
//         item.latitude !== undefined &&
//         item.longitude !== undefined &&
//         !isNaN(item.latitude) &&
//         !isNaN(item.longitude)
//     );
//     const handleMarkerClick = (item) => {
//       setModalData(item);
//       setModalOpen(true);
//       setId(item.id)
//     };

//     const handleModalClose = () => {
//       setModalOpen(false);
//     };

//   return (
//     <>
//     <MapContainer center={center} style={{ height: "50vh",zIndex:"0" }} zoom={13}>
//       <TileLayer
//         url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}"
//         attribution="&copy; OpenStreetMap contributors"
//       />
//       <MarkerClusterGroup chunkedLoading>
//         {validLocations?.map((item, index) => (
//           <>
//           <Marker
//             key={index}
//             position={[item?.latitude, item?.longitude]}
//             icon={markerIcon}
//           >
//             <Popup>
//               <Table>
//                 <tbody>
//                   <tr>
//                     <th> Farmer Name:</th>
//                     <td>{item.fullName}</td>
//                   </tr>
//                   <tr>
//                     <th>Species:</th>
//                     <td>{item.cattleSpecies}</td>
//                   </tr>
//                   <tr>
//                     <th>Age:</th>
//                     <td>{item.cattleAge}</td>
//                   </tr>

//                   <tr>
//                     <th>Breed:</th>
//                     <td>{item.cattleBreed}</td>
//                   </tr>
//                   <tr>
//                     <th>Color:</th>
//                     <td>{item.cattleColor}</td>
//                   </tr>
//                   <tr>
//                     <th>Sum Insured:</th>
//                     <td>{item.cattleSumInsured}</td>
//                   </tr>
//                   <tr>
//                     <th>Address:</th>
//                     <td>{item.address}</td>
//                   </tr>

//                 </tbody>
//                 <div className="d-flex justify-content-center mt-2 ">
//                   <Button
//                     onClick={()=>handleMarkerClick(item)}
//                     className="buttonOrangeDefaultColor2 w-100"
//                      size="sm"
//                      style={{position:"relative",left:"60px"}}
//                   >
//                     View Details
//                   </Button>
//                 </div>
//               </Table>
//             </Popup>
//           </Marker>

//           </>
//         ))}

//       </MarkerClusterGroup>
//     </MapContainer>
//       <Modal show={isModalOpen} onHide={handleModalClose}>
//       <div className="modal-header">
//         <h5 className="modal-title">Cattle Details</h5>

//       </div>
//       <div className="modal-body">
//           <Table>
//             <tbody>
//               <tr>
//                 <th>Farmer Name:</th>
//                 <td>{modalData.fullName}</td>
//               </tr>
//               <tr>
//                 <th>Species:</th>
//                 <td>{modalData.cattleSpecies}</td>
//               </tr>
//               <tr>
//                 <th>Age:</th>
//                 <td>{modalData.cattleAge}</td>
//               </tr>
//               <tr>
//                 <th>Breed:</th>
//                 <td>{modalData.cattleBreed}</td>
//               </tr>
//               <tr>
//                 <th>Color:</th>
//                 <td>{modalData.cattleColor}</td>
//               </tr>
//               <tr>
//                 <th>Sum Insured:</th>
//                 <td>{modalData.cattleSumInsured}</td>
//               </tr>
//               <tr>
//                 <th>Address:</th>
//                 <td>{modalData.address}</td>
//               </tr>
//             </tbody>
//           </Table>

//       </div>
//       <div className="modal-footer">
//         <Button color="secondary" onClick={handleModalClose}>
//           Close
//         </Button>
//       </div>
//     </Modal>
//     </>
//   );
// };

// export default CattleInsurance;

import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import L from "leaflet";
import { Table, Button } from "reactstrap";
import { Modal } from "react-bootstrap";
import { useGetCrmInsuranceLeadsQuery } from "features/Insurance/InsuranceApiSlice";
import "leaflet/dist/leaflet.css";
import { store } from "app/store";
import { API_URL } from "app/config";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import { InsuranceDetailViewModal } from "./InsuranceDetailViewModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";

const markerIcon = new L.Icon({
  iconUrl: "https://cdn-icons-png.flaticon.com/512/9410/9410621.png",
  iconSize: [40, 40],
  iconAnchor: [17, 46],
  popupAnchor: [0, -46],
});
const FitBoundsHandler = ({ locations }) => {
  const map = useMap();

  useEffect(() => {
    if (locations.length > 0 && map) {
      const bounds = L.latLngBounds(
        locations.map((loc) => [loc.latitude, loc.longitude])
      );
      map.fitBounds(bounds, { padding: [50, 50] });
    }
  }, [locations, map]);

  return null;
};

const CattleInsurance = () => {
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 100,
  });

  const queryParameters = {
    page: pagination.page,
    perPage: pagination.perPage,
    selectedProduct: "Cattle",
  };

  const { data, isLoading, isFetching } = useGetCrmInsuranceLeadsQuery(
    queryParameters
  );

  const dataFromApi = data?.data?.results || [];
  const paginationFromApi = data?.data
    ? {
        page: data?.data?.current_page,
        pageCount: data?.data?.pages,
        perPage: data?.data?.per_page,
      }
    : pagination;

  const [center] = useState([28.57659, 77.31433]);

  // const [modalData, setModalData] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [LeadsDataHalf, setLeadsDataHalf] = useState([]);
  const [serviceDetails, setServiceDetails] = useState({});
  const [getDataId, setLeadId] = useState();

  const validLocations = dataFromApi?.flatMap((farmer) => {
      let lat = null,
        lng = null;

      if (typeof farmer?.location === "string") {
        const parts = farmer.location.split(",").map((p) => p.trim());
        if (parts.length === 2) {
          lat = parseFloat(parts[0]);
          lng = parseFloat(parts[1]);
        }
      } else if (
        typeof farmer?.location === "object" &&
        farmer.location !== null
      ) {
        lat = parseFloat(farmer.location.lat || farmer.location.latitude);
        lng = parseFloat(farmer.location.lng || farmer.location.longitude);
      }

      const cattleArray = farmer?.lead_details?.flatMap((lead) =>
        Array.isArray(lead?.service_details?.cattle_data)
          ? lead.service_details.cattle_data.map((cattle) => ({
              id: farmer.id,
              farmerName: farmer.full_name,
              cattleId: cattle.cattle_id,
              cattleTag: cattle.cattle_tag_number,
              cattleTagDate: cattle.cattle_tag_date,
              policy: cattle.policy_details || null,
              latitude: lat,
              longitude: lng,
              address: farmer.address || "N/A",
            }))
          : []
      );

      // return cattleArray || [];
       return {
      id: farmer.id,
      farmerName: farmer.full_name,
      State: farmer.state_name || "-",
      District: farmer.district_name || "-",

      Current_Status: farmer.current_status || "-",


      address: farmer.address || "N/A",

      latitude: lat,
      longitude: lng,
      cattleArray,
    };
    })
    .filter(
      (item) =>
        item &&
        item.latitude !== null &&
        item.longitude !== null &&
        !isNaN(item.latitude) &&
        !isNaN(item.longitude)
    );

  const refetchLeadsData = async (id) => {
    const state = store.getState();
    setLoading(true);
    try {
      const getLeadsData = await axios.get(
        `${API_URL}/api/v1/crm/leads/${id}`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (getLeadsData?.data) {
        setLeadsDataHalf(getLeadsData?.data?.data);
        setLoading(false);
        let finalDataBanking = getLeadsData?.data?.data?.lead_details?.find(
          (item) => item.service_name === "Insurance"
        );
        setServiceDetails(finalDataBanking?.service_details);
      }
    } catch (error) {
      console.error("Error fetching farmer data:", error);
      throw error;
    }
  };

  // Handle Marker Click
  const handleMarkerClick = (item) => {
    // setModalData(item);
    setModalOpen(true);
    setLeadId(item.id);
    refetchLeadsData(item.id);
  };

  const handleModalClose = () => setModalOpen(false);

  const totalPages = paginationFromApi.pageCount || 1;
  const currentPage = paginationFromApi.page || 1;

  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
  return (
    <>
      <div className="d-flex justify-content-end align-items-center mb-2">
        <div>
          {pageNumbers.map((num) => (
            <Button
              key={num}
              size="sm"
              className="me-1"
              color={num === currentPage ? "primary" : "secondary"}
              onClick={() => setPagination((p) => ({ ...p, page: num }))}
            >
              {num}
            </Button>
          ))}
        </div>
      </div>
      {isLoading || isFetching ? (
        <Skeleton count={20} />
      ) : (
        <MapContainer
          center={center}
          style={{ height: "80vh", zIndex: 0 }}
          zoom={12}
        >
          <TileLayer
            url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}"
            attribution="&copy; OpenStreetMap contributors"
          />
          <FitBoundsHandler locations={validLocations} />
          <MarkerClusterGroup chunkedLoading>
            {validLocations?.map((item, index) => (
              <Marker
                key={`${item.cattleId}-${index}`}
                position={[item.latitude, item.longitude]}
                icon={markerIcon}
              >
                <Popup>
                  <Table>
                    <tbody>
                      <tr>
                        <th>Farmer:</th>
                        <td>{item.farmerName}</td>
                      </tr>
                     
                      <tr>
                        <th>State:</th>
                        <td>{item.State}</td>
                      </tr>
                      <tr>
                        <th>District:</th>
                        <td>{item.District}</td>
                      </tr>
                      <tr>
                        
                        <th>Address:</th>
                        <td>{item.address}</td>
                        </tr>
                           <tr>
                        <th>Total Cattle:</th>
                        <td>{Array.isArray(item?.cattleArray)?item?.cattleArray?.length:"-"}</td>
                      </tr>
                      <tr>
                        <th>Current Status:</th>
                        <td className="text-success">{item.Current_Status}</td>
                      </tr>
                    </tbody>
                  </Table>
                  <Button
                    size="sm"
                    className="w-100 mt-2"
                    onClick={() => handleMarkerClick(item)}
                  >
                    View Details
                  </Button>
                </Popup>
              </Marker>
            ))}
          </MarkerClusterGroup>
        </MapContainer>
      )}

      {/* Modal */}
      <Modal show={isModalOpen} onHide={handleModalClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title
            as="div"
            className="fw-bold d-flex justify-content-between align-items-center"
            style={{ width: "100%" }}
          >
            <span style={{ color: "#343737" }}>Lead Information</span>

            <Button
              className="bg-transparent text-black"
              style={{
                border: "1px solid #829999",
                color: "#343737",
              }}
              size="sm"
              onClick={() => refetchLeadsData(getDataId)}
            >
              <FontAwesomeIcon icon={faRotateLeft} />
            </Button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="" style={{ backgroundColor: "#f9f9f9" }}>
          {loading ? (
            <Skeleton count={15} />
          ) : LeadsDataHalf ? (
            <InsuranceDetailViewModal
              serviceDetails={serviceDetails}
              LeadsDataHalf={LeadsDataHalf}
              selectedProduct="Cattle"
              refetchApplication={refetchLeadsData}
              refetch=""
              setDetailsModal={handleModalClose}
            />
          ) : (
            <p style={{ color: "#999", textAlign: "center" }}>
              No lead information available.
            </p>
          )}
        </Modal.Body>
        <div className="modal-footer">
          <Button color="secondary" onClick={handleModalClose}>
            Close
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default CattleInsurance;
